import React from 'react'
import { Setters } from 'src/features/gorilla/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { infielderReducer, initialInfielderState } from 'src/features/gorilla/reducer/infielder'
import { State, PartialAction } from 'src/types'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { gorillaBaseModel as models } from 'src/features/gorilla/constants/baseModel'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/gorilla/constants/actionType'

const GorillaInfielder: React.FC = () => {
  const [state, dispatch] = React.useReducer(infielderReducer, initialInfielderState) as [State, React.Dispatch<PartialAction>]
  const { figurePanelNum } = state
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  return (
    <OrderPageTemplate
      breadcrumbTrail={'硬式 / ごりら印の野球道具 / 内野手用'}
      brand={'gorilla'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default GorillaInfielder
